exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".view-field[data-v-e3c26408]{background-color:#f8f9fa;border:1px solid #e9ecef;border-radius:4px;padding:8px 12px;min-height:58px}.view-field label[data-v-e3c26408]{display:block;font-size:.75rem;font-weight:600;color:#6c757d;margin-bottom:2px;text-transform:uppercase}.view-field .value[data-v-e3c26408]{color:#212529;font-weight:500;font-size:.95rem}.note-table th[data-v-e3c26408]{background-color:#f1f3f5;font-size:.85rem;font-weight:600;text-transform:uppercase;color:#495057}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-e3c26408","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/component/common/ViewNoteDetailsModal.vue
// module id = 1826
// module chunks = 0